import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../lib/auth";
import { AuthShell, Field } from "./Login";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AcceptInvite() {
    const loc = useLocation();
    const nav = useNavigate();
    const { acceptInvite } = useAuth();
    const params = new URLSearchParams(loc.search);
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");

    const submit = async (e) => {
        e.preventDefault();
        if (!token) {
            setErr("Missing invitation token");
            return;
        }
        if (password.length < 8) {
            setErr("Password must be 8+ characters");
            return;
        }
        setBusy(true);
        setErr("");
        try {
            await acceptInvite(token, password);
            toast.success("Welcome to AudRI");
            nav("/dashboard", { replace: true });
        } catch (e2) {
            setErr(formatApiError(e2, "Invitation could not be accepted"));
        } finally {
            setBusy(false);
        }
    };

    return (
        <AuthShell
            eyebrow="Accept invitation"
            title="Set your password"
            sub="Your admin invited you to join their AudRI workspace. Choose a strong password to activate your account."
        >
            <form onSubmit={submit} className="space-y-4">
                <Field
                    label="New password (min 8 characters)"
                    type="password"
                    value={password}
                    onChange={setPassword}
                    autoFocus
                    testid="invite-password"
                />
                {err && (
                    <div className="text-[12px] text-[#991B1B] border border-[#FECACA] bg-[#FEF2F2] px-3 py-2 rounded-sm">
                        {err}
                    </div>
                )}
                <button
                    type="submit"
                    disabled={busy}
                    data-testid="accept-invite-submit"
                    className="w-full inline-flex items-center justify-center gap-2 bg-[#C2410C] text-white text-sm px-4 py-3 rounded-sm hover:bg-[#9A3412] disabled:opacity-60"
                >
                    {busy ? (
                        <Loader2 size={14} className="animate-spin" />
                    ) : (
                        <ShieldCheck size={14} />
                    )}
                    Activate account & sign in
                </button>
            </form>
        </AuthShell>
    );
}
